// extracted by mini-css-extract-plugin
export default {"expand":"DodajArkusz_expand__O7Yjc"};